import MarkdownIt from 'markdown-it';
import type { Block } from '@hump/shared-types';
import type { Parser, ParseResult } from './types';
import { createBlock } from './block-builder';

export class MarkdownParser implements Parser {
  readonly sourceType = 'md' as const;
  private md = new MarkdownIt();

  async parse(input: string): Promise<ParseResult> {
    const tokens = this.md.parse(input, {});
    const blocks: Block[] = [];
    let order = 0;
    let title = 'Untitled';

    for (let i = 0; i < tokens.length; i++) {
      const token = tokens[i];

      if (token.type === 'heading_open') {
        const level = parseInt(token.tag.slice(1), 10);
        // 下一个 inline token 是标题内容
        const inlineToken = tokens[i + 1];
        const content = inlineToken?.content ?? '';
        if (level === 1 && title === 'Untitled') {
          title = content;
        }
        blocks.push(
          createBlock({
            docId: '',
            order: order++,
            type: 'heading',
            level,
            original: content,
          })
        );
      } else if (token.type === 'paragraph_open') {
        const inlineToken = tokens[i + 1];
        const content = inlineToken?.content ?? '';
        if (content.trim()) {
          blocks.push(
            createBlock({
              docId: '',
              order: order++,
              type: 'paragraph',
              original: content,
            })
          );
        }
      } else if (token.type === 'fence') {
        blocks.push(
          createBlock({
            docId: '',
            order: order++,
            type: 'code',
            original: token.content,
          })
        );
      } else if (token.type === 'blockquote_open') {
        const parts: string[] = [];
        for (let j = i + 1; j < tokens.length && tokens[j].type !== 'blockquote_close'; j++) {
          if (tokens[j].type === 'inline') parts.push(tokens[j].content);
        }
        const content = parts.join(' ');
        if (content.trim()) {
          blocks.push(
            createBlock({
              docId: '',
              order: order++,
              type: 'quote',
              original: content,
            })
          );
        }
        // Skip the nested tokens so the outer loop does not re-emit them.
        while (i < tokens.length && tokens[i].type !== 'blockquote_close') i++;
      } else if (token.type === 'image') {
        // 1.13 Markdown 图片提取
        const src = token.attrGet('src') || token.content || '';
        const alt = token.content || '';
        if (src) {
          blocks.push(
            createBlock({
              docId: '',
              order: order++,
              type: 'image',
              imageData: src,
              caption: alt || undefined,
              original: alt,
            })
          );
        }
      }
    }

    return {
      blocks,
      meta: { title, sourceType: 'md', lang: 'en' }, // TODO: placeholder, add language detection in future
    };
  }
}
